import React from "react";
import "./index.css";
import {Input, Select} from 'antd';
import {ManagePolicyController} from "./controller";

const {Option} = Select;

interface PolicyInputProps {
  policyName: string;
  setPolicyName: (value: string) => void;
  policyNameError: string;
  setPolicyNameError: (value: string) => void;
  scopeInfo: string;
  setScopeInfo: (value: string) => void;
  group: string;
  setGroup: (value: string) => void;
  systemResource: string[];
  setSystemResource: (value: string[]) => void;
  scope: string | undefined;
  setScope: (value: string | undefined) => void;
  scopeOptions: string[];
  setScopeOptions: (value: string[]) => void;
  scopeAndActionsVisible: boolean;
  setScopeAndActionsVisible: (value:boolean) => void;
}

export const PolicyInput: React.FC<PolicyInputProps> = ({
                                                          policyName, setPolicyName,
                                                          policyNameError, setPolicyNameError,
                                                          group, setGroup,
                                                          systemResource, setSystemResource,
                                                          scope, setScope,
                                                          scopeOptions, setScopeOptions,
                                                          scopeAndActionsVisible, setScopeAndActionsVisible,
                                                          scopeInfo, setScopeInfo
                                                        }) => {


  const {
    userGroupOptions,
    sisenseDataSources,
    policyInputRequirementsPEV,
    policyNames,
  } = ManagePolicyController();

  const validateAndSetPolicyName = ({target: {value}}) => {
    setPolicyNameError("");
    if (policyNames.includes(value)) {
      setPolicyNameError("Policy name is already taken");
    }
    if (value.length > 40 || value.length < 1) {
      setPolicyNameError("Policy name should be between 1 to 40 characters");
    } 
    setPolicyName(value);
  };


  function resetScopeSelection(values: Array<String>) {
    setScopeAndActionsVisible(true);
    if (scope !== undefined && values.length !==0 ) {
      setScopeInfo("Select the scope as system resource got changed");
    }
    setScope(undefined);
    const selectedSystemResources = sisenseDataSources.filter(systemResource => values.includes(systemResource.systemResourceId))
    const resources = selectedSystemResources.flatMap(systemResource => systemResource.resources || []);
    const actionName = "can_view_dashboards";

    const scopesWithCanViewDashboardAction = resources.flatMap(resource => {
      return resource?.actions?.flatMap(action => {
        if (action.name === actionName) {
          return action.scopes ? action.scopes.map(scope => scope.name) : [];
        } else {
          return [];
        }
      });
    });

    const uniqueScopes = new Set(scopesWithCanViewDashboardAction);
    const commonScopeNames: Array<any> = [];

    uniqueScopes.forEach((scopeName) => {
      if (scopeName !== undefined && scopesWithCanViewDashboardAction.reduce((a, v) => (v === scopeName ? a + 1 : a), 0) === resources.length) {
        commonScopeNames.push(scopeName);
      }
    });
    if (commonScopeNames.indexOf("global") === -1 && values.length !==0) {
      commonScopeNames.push("global");
    }
    setScopeOptions(commonScopeNames);
  }

  if (policyInputRequirementsPEV.progress === null && policyInputRequirementsPEV.error === null && policyInputRequirementsPEV.value !== null) {
    return (
      <div className={"policyInputContainer"}>
        <div>
          <div className="input-fields">
            <div className="policy-input">
              <div className="label">Policy name</div>
              <Input
                id="policy-name"
                value={policyName}
                onChange={validateAndSetPolicyName}
                autoFocus
                className={policyNameError !== "" ? "error-border" : ""}
              />
              <div className="error-detail">{policyNameError}</div>
            </div>
            <div className="policy-input">
              <div className="label">System</div>
              <Input
                id="system-name"
                value="Sisense"
              />
            </div>
          </div>
          <div className="input-fields">
            <div>
              <div className="label">Business teams</div>
              <Select
                showSearch={true}
                options={userGroupOptions}
                id="user-group-id"
                onChange={value => {
                  setGroup(value)
                }}
                value={group}
              />
            </div>
            <div>
              <div className="label">System resources</div>
              <Select
                filterOption={false}
                showSearch={true}
                mode="multiple"
                onChange={(value) => {
                  resetScopeSelection(value)
                  setSystemResource(value)
                }}
                value={systemResource}
                id="system-resource-id"
              >
                {sisenseDataSources.map((sisenseDatasource) => (
                  <Option
                    key={sisenseDatasource.systemResourceId}
                    value={sisenseDatasource.systemResourceId}
                  >
                    {sisenseDatasource.name}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="input-fields" style={{visibility: scopeAndActionsVisible?"visible":"hidden"}} >
            <div>
              <div className="label">Scope</div>
              <Select
                showSearch={true}
                value={scope}
                onChange={(value) => {
                  setScope(value)
                  setScopeInfo("")
                }}
                id="scope"
              >
                {scopeOptions.map((scope) => (
                  <Option
                    key={scope.toLowerCase()}
                    value={scope.toLowerCase()}
                  >
                    {scope}
                  </Option>
                ))}
              </Select>
              <div className="error-detail">{scopeInfo}</div>
            </div>
            <div>
              <div className="label">Access type</div>
              <Input
                id="access-type"
                value="Can view dashboards"
              />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div></div>
  }
};

export default PolicyInput;
